
import { Component, Inject, Vue } from 'vue-property-decorator';
import DefaultContainer from '@/app/Survey/components/DefaultContainer.vue';
import CustomStylor from '@/app/Survey/config/CustomStylor';
import DataUrl from '@/app/Survey/model/DataUrl';
import FormService from '@/services/FormService';

@Component({ components: { DefaultContainer } })
export default class DefaultEndingPage extends Vue {
    @Inject() public formService!: FormService;

    public async mounted(): Promise<void> {
        await this.loadAppearanceTheme();
    }

    private isThemeAlreadyLoaded(): boolean {
        return !!document.querySelector('link[href*="bootstrap.solucx.com.br"]');
    }

    private async loadAppearanceTheme(): Promise<void> {
        if (this.isThemeAlreadyLoaded()) return;
        try {
            const urlData = new DataUrl(this.$route);
            const form = await this.formService.getFormById(Number(urlData.formId), Number(urlData.transactionId));
            if (form?.appearance?.mainColor) {
                const customStylor = new CustomStylor(document);
                await customStylor.mountStyle(encodeURIComponent(form.appearance.mainColor));
            }
        } catch (err) {
            console.error('Failed to load appearance theme:', err);
        }
    }
}
